import { gql } from '../__generated__';

export const PERFORM_CHECK_OUT = gql(`
  mutation PerformCheckOut($accessGrantId: String!) {
    performCheckOut(accessGrantId: $accessGrantId) {
      success
    }
  }
`);
